import { gql } from "@apollo/client";import { useQuery } from "@apollo/client/react";import React from 'react';

import MainContent from '../../components/mainContent/MainContent';
import TerminosAll from './components/TerminosAll';
import ErrorDialog from '../../components/ErrorDialog';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { useTerminosAll } from '../../components/hooks/useTerminosAll';

export default function TerminosAdmin({ setChildrenAction }) {

  const navigate = useNavigate();

  const handleCloseDlgError = () => {
    // En este punto inicial donde el error solo puede deberse a problemas de conexión, al cerrar el dlg
    // retorno al home.
    navigate("/menu");
  };

  const { loading, error, data } = useTerminosAll();

  if (loading) return <MainContent component={<CircularProgress disableShrink />} titulo='Administración Términos y Condiciones' />;

  if (error) {
    return (
      <>
          <MainContent titulo='Administración Términos y Condiciones' />        

          <ErrorDialog
          id="dlg-error-terminos-all"
          open={error != null}
          onClose={handleCloseDlgError}
          mensaje="ERRORDB" />
        

        </>);

  }

  if (data) {
    if (data.terminosAll.success) {
      return (
        <MainContent component={<TerminosAll data={data} setChildrenAction={setChildrenAction} />} titulo='Administración Términos y Condiciones' />);

    } else
    {
      return (
        <ErrorDialog
          id="dlg-error-terminos-all"
          open={data.terminosAll.error}
          onClose={handleCloseDlgError}
          mensaje={data.terminosAll.error} />);


    }
  }
};